import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e2ab38ee"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loadmore: require('/home/forge/meidenvanholland.nl/components/loadmore.vue').default,Banner: require('/home/forge/meidenvanholland.nl/components/banner.vue').default})
